import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import image1 from './0FED7426-F28C-4570-92E2-F4E881C715CA.jpeg'
import image2 from'./C3AA65CE-EAF8-4DB9-BCF2-D16B0E43AF08.jpeg'
import image3 from './6AB4875F-5108-409B-AEB6-ED44A45C0EF1_1_105_c.jpeg'
import image4 from './252516D1-655B-45D3-9F68-E08D651B4BE7_1_105_c.jpeg'
import image5 from './E4A3527D-5FFA-4780-BC05-EB6F6CD212D6.png'
import image6 from './5367F1E9-B818-4EE4-8293-92D6F00155F4_1_105_c.jpeg'
import image7 from './BFD1EAE4-3EA9-4616-97F1-771D9D55D03B_1_105_c.jpeg'
import image8 from './B28EE83C-0C81-43C9-B443-6E456CA0C459_1_105_c.jpeg'
import image9 from './8CFA668D-6897-458C-AF13-54538DA0A6DA.png'
import image10 from './914D9931-1F19-4E34-8360-2B426B41A162_1_105_c.jpeg'
import image11 from './Screenshot 2024-08-22 at 10.53.44 PM.png'
import image12 from './23E6916C-9630-4DC8-BBA3-110BF2B80FC6_1_105_c.jpeg'
import image13 from './5CD9F463-FA6E-422F-A2E5-46147444637B_1_201_a.jpeg'
import image14 from './165C226E-3014-46AA-9621-E03054A27DD1_1_105_c.jpeg'
import image15 from './Screenshot 2024-08-22 at 10.59.42 PM.png'
import image16 from './459C4E9D-9D62-49D2-A971-D3E6B3AF09FC_1_105_c.jpeg'
import image17 from './C3B1B0AD-3E46-45A8-BB73-C715B3D04831_1_105_c.jpeg'
import image18 from './Screenshot 2024-08-22 at 11.05.32 PM.png'
import image19 from './Screenshot 2024-08-22 at 11.07.00 PM.png'
import image20 from './D05FB006-08A7-41A3-83EF-95BBF4493C5A_1_105_c.jpeg'
import image21 from './Screenshot 2024-08-22 at 11.10.58 PM.png'
import image22 from './IMG_0057.JPG'
import image23 from './IMG_5009.JPG'
import image24 from './Screenshot 2024-08-22 at 11.17.28 PM.png'
import image25 from './IMG_0640.JPG'
import image26 from './IMG_0642.JPG'
import image27 from './Screenshot 2024-08-22 at 11.22.02 PM.png'
import image28 from './Screenshot 2024-08-22 at 11.28.49 PM.png'
import image29 from './IMG_1150.JPG'
import image30 from './IMG_1216.JPG'
import image31 from './IMG_2384.JPG'
import image32 from './Screenshot 2024-08-22 at 11.34.56 PM.png'
import image33 from './Screenshot 2024-08-22 at 11.38.07 PM.png'
import image34 from './Screenshot 2024-08-22 at 11.39.57 PM.png'
import image35 from './Screenshot 2024-08-22 at 11.42.59 PM.png'
import image36 from './Screenshot 2024-08-22 at 11.45.15 PM.png'
import image37 from './IMG_3497.JPG'
import image38 from './Screenshot 2024-08-22 at 11.47.54 PM.png'
import image39 from './Screenshot 2024-08-22 at 11.49.37 PM.png'
import image40 from './Screenshot 2024-08-22 at 11.51.31 PM.png'
import image41 from './IMG_4469.JPG'
import image42 from './Screenshot 2024-08-22 at 11.53.51 PM.png'
import image43 from './Designer.png';

export default function Pictures() {
    const images = [
        "https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
        "https://images.unsplash.com/photo-1506710507565-203b9f24669b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1536&q=80",
        "https://images.unsplash.com/photo-1536987333706-fc9adfb10d91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
    ];
  return (
    

        <Slide>
            <div style={{
          display: "flex", 
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center"// Optional shadow for a 3D effect
        }} className="each-slide-effect">
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '30vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image1}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Year1</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '30vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image2}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}></span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '20%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image3}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Wonderland Halloween</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image4}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Waterloo</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image5}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>First time Chic Fil a and you had tummy ache</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '30vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image6}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Christmas</span>

            </div>
                        <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image7}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Formal</span>

            </div>            
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image8}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Year 2 Covid Year</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image9}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Yes I ur besti bb</span>

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image10}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Sad you no longer on my wall anymore</span>

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image11}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Arcade</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image12}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Year 3 Anniversary hangout at our fav place the condo</span>

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image13}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}> Suprise birthday party that you did for me</span>

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '50%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image14}
        alt=""
      />

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image15}
        alt=""
      />

            </div>


            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image16}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}> Look what you did</span>

            </div>


            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image17}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}> Valentines day</span>

            </div>


            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '43%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image18}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}> Birthday Girl</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image19}
        alt=""
      />

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image20}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}> We go to first wedding together </span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image21}
        alt=""
      />

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '60%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image22}
        alt=""
      />

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image23}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}> Year 4 </span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '40%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image24}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Alchoholic</span>

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image25}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Pretty Sunset pretty GF</span>

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '60%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image26}
        alt=""
      />

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image27}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Bday girll</span>

            </div>


            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '45%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image28}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Bday girll part 2</span>

            </div>


            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image29}
        alt=""
      />

            </div>



            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image30}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>My bb GRADUATED</span>

            </div>


            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '58%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image31}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Year 5!!!!</span>

            </div>

            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image32}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>I cant believe you liked me when I was bald</span>

            </div>  

                        <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image33}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>You put my hand on your head to act like I abuse you, you drama queen</span>

            </div>

            

                        <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image34}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Cottage trip</span>

            </div> 
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image35}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>After she have too much fun at the casino because she an addict</span>

            </div> 
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '50%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image36}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Big Fat Casino Addict</span>

            </div> 
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image37}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>After she have too much fun at the casino because she an addict</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '50%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image38}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Celebrating your bday with my family</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image39}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Going to Myth with bday girl</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '50%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image40}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Going to Myth with bday girl</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '50%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image41}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Golden Hour part 2</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '30%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image42}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>Graduating with my bb</span>

            </div>
            <div className="each-slide-effect"
             style={{
                display: "flex", 
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"// Optional shadow for a 3D effect
              }}>
            <img
        style={{
          backgroundSize: 'cover',
          width: '50%',
          height: '48vh',
          border: '5px solid pink', // Add a pink border
          borderRadius: '15px', // Rounded corners for a more aesthetic look
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for a 3D effect
        }}
        src={image43}
        alt=""
      />
      <span style={{ fontFamily: 'Brush Script MT', color: 'pink', fontSize: "10vh"}}>More pics coming in year 6,7,8 and more</span>

            </div>

            
        </Slide>
  )


}
